import axiosInstance from '@/utils/axiosInstance';

// =============================== //
// Review Service Functions        //
// =============================== //

export async function getAllReviews() {
    const { data } = await axiosInstance.get('/performance/reviews');
    return data;
}

// =============================== //
// Appraisal Service Functions     // 
// =============================== //

export async function assignAppraisal(employeeId, templateId, cycleName, deadline) {
    const { data } = await axiosInstance.post('/performance/appraisals/assign', {
        employeeId,
        templateId,
        cycleName,
        deadline,
    });
    return data;
}

export async function bulkAssignAppraisals(employeeIds, templateId, cycleName, options = {}) {
    const { data } = await axiosInstance.post('/performance/appraisals/bulk-assign', {
        employeeIds,
        templateId,
        cycleName,
        startDate: options.startDate,
        deadline: options.deadline,
        department: options.department,
        templateAssignments: options.templateAssignments,
    });
    return data;
}

export async function getAppraisals() {
    const { data } = await axiosInstance.get(`/performance/appraisals`);
    return data;
}

export async function getAppraisalDetails(appraisalId) {
    const { data } = await axiosInstance.get(`/performance/appraisals/${appraisalId}`);
    return data;
}

export async function submitAppraisalReview(appraisalId, reviewType, data) {
    const { data: responseData } = await axiosInstance.post(`/performance/appraisals/review`, {
        appraisalId,
        reviewType,
        ...data
    });
    return responseData;
}

// =============================== //
// PIP Service Functions           // 
// =============================== //

export async function createPIP(employeeId, templateId, reason, startDate, endDate, milestones) {
    const { data } = await axiosInstance.post('/performance/pips/create', {
        employeeId,
        templateId,
        reason,
        startDate,
        endDate,
        milestones
    });
    return data;
}

export async function getPIPs() {
    const { data } = await axiosInstance.get('/performance/pips');
    return data;
}

export async function getExitInterviews() {
    const { data } = await axiosInstance.get('/performance/exit-interviews');
    return data;
}

export async function getExitInterviewDetails(exitInterviewId) {
    const { data } = await axiosInstance.get(`/performance/exit-interviews/${exitInterviewId}`);
    return data;
}

export async function submitExitInterview(exitInterviewId, submitData) {
    const { data } = await axiosInstance.post(`/performance/exit-interviews/${exitInterviewId}/submit`, submitData);
    return data;
}

export async function approveExitInterview(exitInterviewId, approveData = {}) {
    const { data } = await axiosInstance.post(`/performance/exit-interviews/${exitInterviewId}/approve`, approveData);
    return data;
}

export async function getExitInterviewEligibleEmployees() {
    const { data } = await axiosInstance.get('/performance/exit-interviews/eligible-employees');
    return data;
}

export async function assignExitInterview(employeeId, templateId) {
    const { data } = await axiosInstance.post('/performance/exit-interviews/assign', {
        employeeId,
        templateId,
    });
    return data;
}

export async function getPIPDetails(pipId) {
    const { data } = await axiosInstance.get(`/performance/pips/${pipId}`);
    return data;
}

export async function savePIP(pipId, saveData) {
    const { data } = await axiosInstance.post(`/performance/pips/${pipId}/save`, {
        pipId,
        ...saveData
    });
    return data;
}

// =============================== //
// Cancellation Service Function   // 
// =============================== //

export async function cancelReview(reviewId, reason) {
    const { data } = await axiosInstance.patch(`/performance/reviews/${reviewId}/cancel`, { reason });
    return data;
}

// =============================== //
// Deletion Service Functions      // 
// =============================== //

export async function deleteReview(reviewId) {
    const { data } = await axiosInstance.delete(`/performance/reviews/${reviewId}`);
    return data;
}

// =============================== //
// Reminder Service Functions      // 
// =============================== //

export async function sendReminder(reviewIds) {
    const { data } = await axiosInstance.post('/performance/reminders', {
        reviewIds
    });
    return data;
}
